module.exports = __webpack_public_path__ + "img/群防群治管理平台.3c732a18.png";